import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const facebook = defineConnector({
  identifier: "facebook",
  name: "Facebook",
  tagLine: "Social network and business platform",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://graph\\.facebook\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Facebook app",
      items: [
        {
          kind: "markdown",
          content:
            "Open [Meta for Developers](https://developers.facebook.com/apps/), create an app, and add the Facebook products your integration needs. Copy the app ID and app secret from the app settings.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/facebook/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Facebook account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Facebook account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://www.facebook.com/v22.0/dialog/oauth",
    tokenEndpoint: () => "https://graph.facebook.com/v22.0/oauth/access_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.facebook.com/",
  },
});
